import { MediaStoryCard } from '@components/display/cards';
import { APP_PREFIX_PATH } from '@constants/common';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Grid2, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useGetPublicNewsQuery } from '@news/services';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

const ITEMS_PER_PAGE_MD = 4;
const ITEMS_PER_PAGE_SM = 3;

export const OverviewNews = () => {
    const theme = useTheme();
    const intl = useIntl();

    const isMdOrAbove = useMediaQuery(theme.breakpoints.up('md'));
    const { data: latestNews, isLoading: isOverviewNewsLoading } = useGetPublicNewsQuery({
        page: 1,
        page_size: isMdOrAbove ? ITEMS_PER_PAGE_MD : ITEMS_PER_PAGE_SM,
    });

    return !!latestNews?.count || isOverviewNewsLoading ? (
        <Box component="section" px={{ xs: '20px', md: '65px' }} py="25px">
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb="26px">
                <Typography fontFamily="museo-sans" fontSize={32} fontWeight={600} letterSpacing={-1}>
                    <FormattedMessage id="overview.latestNews" defaultMessage="Latest News" />
                </Typography>
                <Button
                    component={Link}
                    to={APP_PREFIX_PATH + '/news'}
                    variant="text"
                    endIcon={<ArrowForwardIcon />}
                    className="min-w-fit font-medium"
                >
                    <FormattedMessage id="common.actions.showAll" defaultMessage="Show all" />
                </Button>
            </Stack>
            <Grid2 container spacing="32px" justifyContent={isOverviewNewsLoading ? 'space-between' : undefined}>
                {isOverviewNewsLoading
                    ? Array.from({ length: isMdOrAbove ? ITEMS_PER_PAGE_MD : ITEMS_PER_PAGE_SM }).map((_, index) => (
                          <Grid2 key={`news-skeleton-${index}`} size={{ xs: 12, md: 3 }}>
                              <MediaStoryCard
                                  key={`news-skeleton-${index}`}
                                  image={{
                                      url: '/static/img/backgrounds/LeftSplitImageDesktop1.png',
                                      alt_text: intl.formatMessage({
                                          id: 'news.loadingThumbnail',
                                          defaultMessage: 'Loading news thumbnail',
                                      }),
                                  }}
                                  baseUrl=""
                                  date="Loading"
                                  slug="123"
                                  title="Loading"
                                  loading
                              />
                          </Grid2>
                      ))
                    : latestNews?.results.map((news) => (
                          <Grid2
                              key={news.id}
                              size={{
                                  xs: 12,
                                  md: 3,
                              }}
                          >
                              <MediaStoryCard
                                  key={`news-${news.id}`}
                                  baseUrl={APP_PREFIX_PATH + '/news/'}
                                  slug={news.id.toString()}
                                  image={{
                                      url: news.picture ?? '',
                                      alt_text: intl.formatMessage(
                                          { id: 'news.thumbnail', defaultMessage: 'Thumbnail for {title}' },
                                          { title: news.title }
                                      ),
                                  }}
                                  date={news.date}
                                  title={news.title ?? ''}
                                  link={{
                                      url: news.id.toString(),
                                  }}
                              />
                          </Grid2>
                      ))}
            </Grid2>
        </Box>
    ) : null;
};
